import { render, staticRenderFns } from "./AddTrade.vue?vue&type=template&id=5ac61171&scoped=true&"
import script from "./AddTrade.vue?vue&type=script&lang=js&"
export * from "./AddTrade.vue?vue&type=script&lang=js&"
import style0 from "./AddTrade.vue?vue&type=style&index=0&id=5ac61171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac61171",
  null
  
)

export default component.exports